import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import RegistrationCompletion from './pages/public/RegistrationCompletion';
import './styles/globals.css';
import { installAsciiDigitPresentation } from './lib/asciiDigits';

installAsciiDigitPresentation();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {window.location.pathname === '/complete-registration' ? <RegistrationCompletion /> : <App />}
  </React.StrictMode>
);